/**
 * 房间
 */
import React from 'react';
import cls from 'classnames';
import intl from 'react-intl-universal';
import { Tooltip } from 'antd';
import IconFont from '@/components/IconFont';
import {
  RoomCleanStatus,
  RoomMainStatus,
  ERoomArrangeTypeTipMap,
  CustomUnableBookStatus,
  EnableBookEnum,
} from '@/config/constant';
import { RoomItem } from '@/redux/reducers/reservation/base.d';
import { DateType } from '@/utils/date';

import CalendarTrigger from './Calendar';
import styles from './index.module.scss';

const MainStatusMap = {
  [RoomMainStatus.Vacant]: {
    text: intl.get('reservation_cmp_room_item_vacant_label'),
    name: styles.statusVacant,
  },
  [RoomMainStatus.Reserved]: {
    text: intl.get('reservation_cmp_room_item_reserve_label'),
    name: styles.statusReserved,
  },
  [RoomMainStatus.Occupied]: {
    text: intl.get('reservation_cmp_room_item_checkin_label'),
    name: styles.statusOccupied,
  },
  [RoomMainStatus.OutService]: {
    text: intl.get('reservation_cmp_room_item_disabled_label'),
    name: styles.statusOutService,
  },
  [RoomMainStatus.PreAssigned]: {
    text: intl.get('reservation_cmp_room_item_preassign_label'),
    name: styles.statusPreAssigned,
  },
  // 待排房
  [-99]: {
    text: intl.get('reservation_cmp_room_item_queue_label'),
    name: styles.statusWaiting,
  },
};

// v2.21新增
const UnableBookStatusMap = {
  [CustomUnableBookStatus.Stop]: {
    text: intl.get('reservation_cmp_room_item_disabled_label'),
    name: styles.statusOutService,
  },
  [CustomUnableBookStatus.Full]: {
    text: intl.get('reservation_cmp_room_item_full_label'),
    name: styles.statusOutService,
  },
  [-9]: {
    // 入住换房 & 预订换排房 时有该标签
    text: intl.get('reservation_cmp_room_item_origin_label'),
    name: styles.statusOutService,
  },
};

interface IProps {
  data: RoomItem;
  showCalendar: boolean;
  businessDate?: DateType;
  showOriginTag?: boolean; // 是否展示为“原” ：原本的房间 展示为“原” 不可再更换成此房间（v2.21）
}

const Index: React.FC<IProps> = (props) => {
  const { data, showCalendar, businessDate, showOriginTag } = props;
  const { roomNo, id, cleanStatus, mainStatus, bookingInfo, unableBookStatus } = data;
  let roomConfig = MainStatusMap[mainStatus];
  const { enableBook, unableBookReasonType } = bookingInfo || {};

  // v2.21 停用房 会出现两种：可订 & 不可订;  新增“满” 优先级高于其他
  if (
    unableBookStatus === CustomUnableBookStatus.Stop ||
    unableBookStatus === CustomUnableBookStatus.Full
  ) {
    roomConfig = UnableBookStatusMap[unableBookStatus];
  }

  // 展示为“原” ：原本的房间 展示为“原” 不可再更换成此房间（v2.21）
  if (showOriginTag) {
    roomConfig = UnableBookStatusMap[-9];
  }

  return (
    <CalendarTrigger
      roomId={id}
      roomNo={roomNo}
      businessDate={businessDate}
      showCalendar={showCalendar}
    >
      <div className={cls(styles.roomItemInfo, 'room-item-info')}>
        <span className={cls(styles.roomItemStatus, roomConfig.name)}>{roomConfig.text}</span>
        <span className={cls(styles.roomItemNo, 'room-item-numeral')}>{roomNo}</span>
        <span className={styles.roomStatusIcon}>
          {/* 不可选房原因提示(“停”“满”来自于后端；“原”前端自己判断) */}
          {enableBook === EnableBookEnum.unableBook || showOriginTag ? (
            <Tooltip
              placement="top"
              overlayStyle={{ zIndex: 9999 }}
              title={
                showOriginTag
                  ? ERoomArrangeTypeTipMap[-9]
                  : ERoomArrangeTypeTipMap[unableBookReasonType]
              }
            >
              <IconFont type="icon-tishi" className={styles.countTipIcon} />
            </Tooltip>
          ) : null}
          {/* 脏房标识 */}
          {cleanStatus === RoomCleanStatus.Dirty ? (
            <IconFont type="icon-extend-dirty-status" style={{ marginLeft: '3px' }} />
          ) : null}
        </span>
      </div>
    </CalendarTrigger>
  );
};

export default Index;
